export default async function productConstructor({main, on, elm, state, subscribe}) {
    main(_ => {
        subscribe('options-change', optionsChanged);
    });

    const optionsChanged = async function (selectedOptions) {
        const selectedOptionsSet = new Set(selectedOptions.constructor);
        const model = state.get();

        const constructor = model.constructor.find(({options}) => {
            return options.every((el) => {
                return selectedOptionsSet.has(`${el.option}:${el.value}`);
            });
        });

        const svgUrl = `/image/${constructor.svg}`;
        if (model.svgUrl !== svgUrl) await loadInlineSvg(svgUrl);
        state.set(s => s.svgUrl = svgUrl);

        const colors = Object.entries(selectedOptions.colors);
        colors.forEach(([prop, value]) => {
            elm.style.setProperty(`--${prop}`, value);
        });

        const images = Object.entries(selectedOptions.images);
        elm.querySelectorAll('.constructor__component').forEach(el => el.remove());

        images.forEach(([prop, image]) => {
            const img = document.createElement('img');
            img.src = image;
            img.classList.add('constructor__component');
            elm.insertAdjacentElement('beforeend', img);
        });

        // console.log(colors);
    };

    const loadInlineSvg = async function (url) {
        const response = await fetch(url, {cache: 'force-cache'});

        if (!response.ok) {
            throw new Error(`SVG load failed: ${response.status}`);
        }

        elm.innerHTML = await response.text();
    }
}

export const model = {
    svgUrl: null
};